import React, { useState } from "react";
import HeaderLayout from "../../components/Header";
import FooterLayout from "../../components/Footer";
import { useSearchParams } from "react-router-dom";
import { Form, Input, Button, Select, Typography, Card, App } from "antd";
import "./Contact.css";
import axios from "axios";

const { Title, Paragraph } = Typography;
const { Option } = Select;

const Contact = () => {
  const { notification, message } = App.useApp();
  const [searchParams] = useSearchParams();
  const [form] = Form.useForm();

  const isModule = searchParams.get("app");

  const handleSubmit = async (values) => {
    try {
      // return console.log(values);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/contact/submit`,
        values
      );

      if (!response.data.error) {
        message.success("Message sent successfully!");
        form.resetFields();
      } else {
        message.error(response.data.message || "Something went wrong.");
      }
    } catch (error) {
      message.error("Failed to send message. Please try again later.");
    }
  };

  return (
    <>
      <HeaderLayout />
      <div>
        <div
          style={{
            // padding: "2rem",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.6",
          }}
        >
          <div className="contact-page">
            <div className="contact-header">
              <h2 align="center">Contact Us</h2>
              <Paragraph>
                We are always here to help you. If you have any questions or
                concerns, please fill out the form and our team will contact you
                as soon as possible.
              </Paragraph>
            </div>

            <Card className="contact-card" bordered={false}>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                requiredMark="optional"
              >
                <Form.Item
                  label="Full name *"
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your name" },
                  ]}
                >
                  <Input placeholder="" />
                </Form.Item>

                <Form.Item
                  label="Email address *"
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your email" },
                    { type: "email", message: "Enter a valid email" },
                  ]}
                >
                  <Input placeholder="E.g. name@email.com" />
                </Form.Item>

                <Form.Item
                  label="Subject *"
                  name="subject"
                  rules={[
                    { required: true, message: "Please enter a subject" },
                  ]}
                >
                  <Input placeholder="" />
                </Form.Item>

                <Form.Item
                  label="Question/Enquiry *"
                  name="message"
                  rules={[
                    { required: true, message: "Please enter your message" },
                  ]}
                >
                  <Input.TextArea rows={4} placeholder="" />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" block>
                    Send
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </div>
      </div>
      <FooterLayout />
    </>
  );
};

export default Contact;
